export default class WeditApi {
  public static URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'
  public static CLIENT_UUID = process.env.REACT_APP_WEDIT_CLIENT_UUID || ''
}
